module.exports = __webpack_public_path__ + "static/media/banner-bg.2c7731be.svg";